// extracted by mini-css-extract-plugin
export default {"swiper":"swiperstyles_swiper__GWixk","swiper_slide":"swiperstyles_swiper_slide__bAD7w"};